<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate="" [formGroup]="editForm" (ngSubmit)="save(editForm.value)">
    <modal-header [plugin]="plugin" [menuModal]="menuModal" [menuComponent]="menuComponent"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <h2>
          <span>{{ 'plugins.installationcustomerattendees.header' | translate }}</span>
        </h2>
        <button
          type="button"
          *ngIf="formData.controls.length === 0"
          class="ir-btn ir-btn--title ir-txt--right"
          style="margin-bottom: 2em"
          (click)="import()"
        >
          <span>{{ 'plugins.installationcustomerattendees.import-contacts' | translate }}</span>
        </button>
      </div>
      <div
        class="ir-content--modal th-content th-content-customer"
        formArrayName="attendees"
        *ngFor="let item of formData.controls; let i = index"
      >
        <table class="ir-modal-table">
          <tr>
            <td class="th-plugin-line--data"></td>
            <td class="th-plugin-line--remove th-plugin-line--remove-customer" colspan="2" align="right">
              <i class="material-icons" (click)="openAttendeeDeleteConfirm(i)">remove_circle</i>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span style="margin-left: 10px">{{
                  'plugins.installationcustomerattendees.first-name' | translate
                }}</span>
              </h2>
            </td>
            <td class="margin-big" [formGroupName]="i">
              <input name="FirstName" class="ir-form-set" type="text" formControlName="FirstName" />
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span style="margin-left: 10px">{{
                  'plugins.installationcustomerattendees.last-name' | translate
                }}</span>
              </h2>
            </td>
            <td class="margin-big" [formGroupName]="i">
              <input name="LastName" class="ir-form-set" type="text" formControlName="LastName" />
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span style="margin-left: 10px">{{ 'plugins.installationcustomerattendees.company' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big" [formGroupName]="i">
              <input name="Company" class="ir-form-set" type="text" formControlName="Company" />
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span style="margin-left: 10px">{{
                  'plugins.installationcustomerattendees.job-function' | translate
                }}</span>
              </h2>
            </td>
            <td class="margin-big" [formGroupName]="i">
              <input name="JobFunction" class="ir-form-set" type="text" formControlName="JobFunction" />
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span style="margin-left: 10px">{{ 'plugins.installationcustomerattendees.phone' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big" [formGroupName]="i">
              <div class="ir-form-group">
                <validation-message
                  [validationControl]="formData.controls[i].controls['Phone']"
                  [validationName]="'minlength'"
                  [errorMessage]="'Phone number not valid'"
                ></validation-message>
                <input name="Phone" class="ir-form-set" type="text" formControlName="Phone" />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span style="margin-left: 10px">{{ 'plugins.installationcustomerattendees.email' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big" [formGroupName]="i">
              <div class="ir-form-group">
                <validation-message
                  [validationControl]="formData.controls[i].controls['Email']"
                  [validationName]="'emailvalidator'"
                  [errorMessage]="'Email not valid'"
                ></validation-message>
                <input name="Email" class="ir-form-set" type="text" formControlName="Email" />
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div class="ir-content--modal th-content th-content-plus">
        <table class="ir-modal-table">
          <tr class="th-plugin-line--add th-plugin-line--add-customer">
            <td colspan="4">
              <i class="material-icons" (click)="add()">add_circle</i>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <modal-footer [editForm]="editForm" [processing]="processing"></modal-footer>
  </form>
</div>
<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<modal (modalOutput)="add($event)" #importCustomersModal></modal>
<confirm
  #attendeeDeleteConfirm
  (confirmOutput)="remove($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.installationcustomerattendees.sure-to-delete' | translate"
  [danger]="true"
></confirm>
<confirm
  #pluginDeleteConfirm
  (confirmOutput)="deletePlugin()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
